module.exports = {
    //UAT
    API_URL: 'https://gf6k30i1z5.execute-api.ap-southeast-1.amazonaws.com/stg',
  
    //SIT
    // API_URL: 'http://172.30.83.37/rhb/api',

    // PROD
    // API_URL: 'xxx',
};